<script setup>
import router from './routes';
import { shallowRef, inject, onMounted, computed } from 'vue';
import { ModalsContainer } from 'vue-final-modal'
import HeaderVue from '@client/js/components/Header.vue';
import Hero from '@client/js/components/Hero.vue';
import MenuCategories from '@client/js/components/MenuCategories.vue';
import FooterVue from '@client/js/components/Footer.vue';
import { useCustomerStore } from '@client/js/store/customer';
import useOrderStore from '@client/js/store/order';
import useCartStore from '@client/js/store/cart';
import { useProductStore } from '@client/js/store/products';
import { useVfm } from 'vue-final-modal';
import { useCheckoutModal } from '@client/js/composables/useCheckoutModal';
import { FLOW } from '@client/js/shared/constants';

let rootData = inject('rootData');

const customerStore = useCustomerStore();
const orderStore = useOrderStore();
const cartStore = useCartStore();
const productStore = useProductStore();

const { open: _open, close: _close } = useCheckoutModal();

// CURR: categories filtered by order type
const categories = computed(() => productStore.filteredCategories);
// const categories = shallowRef([
//   { id: 1, name: 'Beverages', uuid: 'cat-001', sortOrder: 1, type: 'category', parent: 0, items: ['item1', 'item2', 'item3'] },
//   { id: 2, name: 'Appetizers', uuid: 'cat-002', sortOrder: 2, type: 'category', parent: 0, items: ['item4', 'item5'] },
//   { id: 3, name: 'Main Courses', uuid: 'cat-003', sortOrder: 3, type: 'category', parent: 0, items: ['item6', 'item7', 'item8'] },

//   { id: 4, name: 'Desserts', uuid: 'cat-004', sortOrder: 4, type: 'category', parent: 0, items: ['item9', 'item10'] },
//   { id: 5, name: 'Sides', uuid: 'cat-005', sortOrder: 5, type: 'category', parent: 0, items: ['item11', 'item12', 'item13'] },
//   { id: 6, name: 'Breakfast', uuid: 'cat-006', sortOrder: 6, type: 'category', parent: 0, items: ['item14', 'item15'] },
//   { id: 7, name: 'Cold Drinks', uuid: 'cat-007', sortOrder: 1, type: 'subcategory', parent: 1, items: ['item16', 'item17'] },
//   { id: 8, name: 'Hot Drinks', uuid: 'cat-008', sortOrder: 2, type: 'subcategory', parent: 1, items: ['item18', 'item19'] },
//   { id: 9, name: 'Fried Appetizers', uuid: 'cat-009', sortOrder: 1, type: 'subcategory', parent: 2, items: ['item20', 'item21'] },
//   { id: 10, name: 'Fresh Appetizers', uuid: 'cat-010', sortOrder: 2, type: 'subcategory', parent: 2, items: ['item22'] },
//   { id: 11, name: 'Beef Dishes', uuid: 'cat-011', sortOrder: 1, type: 'subcategory', parent: 3, items: ['item23', 'item24'] },
//   { id: 12, name: 'Chicken Dishes', uuid: 'cat-012', sortOrder: 2, type: 'subcategory', parent: 3, items: ['item25', 'item26', 'item27'] },
//   { id: 13, name: 'Fish Dishes', uuid: 'cat-013', sortOrder: 3, type: 'subcategory', parent: 3, items: ['item28'] },
//   { id: 14, name: 'Cakes', uuid: 'cat-014', sortOrder: 1, type: 'subcategory', parent: 4, items: ['item29', 'item30'] },
//   { id: 15, name: 'Ice Cream', uuid: 'cat-015', sortOrder: 2, type: 'subcategory', parent: 4, items: ['item31'] },
//   { id: 16, name: 'Vegetables', uuid: 'cat-016', sortOrder: 1, type: 'subcategory', parent: 5, items: ['item32', 'item33'] },
//   { id: 17, name: 'Grains', uuid: 'cat-017', sortOrder: 2, type: 'subcategory', parent: 5, items: ['item34', 'item35'] },
//   { id: 18, name: 'Pancakes', uuid: 'cat-018', sortOrder: 1, type: 'subcategory', parent: 6, items: ['item36', 'item37'] },
//   { id: 19, name: 'Eggs', uuid: 'cat-019', sortOrder: 2, type: 'subcategory', parent: 6, items: ['item38', 'item39'] },
//   { id: 20, name: 'Smoothies', uuid: 'cat-020', sortOrder: 3, type: 'subcategory', parent: 1, items: ['item40'] },
//   { id: 21, name: 'Salads', uuid: 'cat-021', sortOrder: 7, type: 'category', parent: 0, items: ['item41', 'item42', 'item43', 'item44', 'item45', 'item46', 'item47', 'item48', 'item49', 'item50', 'item51'] },
//   { id: 22, name: 'Soups', uuid: 'cat-022', sortOrder: 8, type: 'category', parent: 0, items: ['item52', 'item53', 'item54', 'item55', 'item56', 'item57', 'item58', 'item59', 'item60', 'item61', 'item62', 'item63'] },
//   { id: 23, name: 'Sandwiches', uuid: 'cat-023', sortOrder: 9, type: 'category', parent: 0, items: ['item64', 'item65', 'item66', 'item67', 'item68', 'item69', 'item70', 'item71', 'item72', 'item73', 'item74', 'item75', 'item76'] },

//   // new subcategories for parents 1,2,3
//   { id: 24, name: 'Tea & Coffee', uuid: 'cat-024', sortOrder: 4, type: 'subcategory', parent: 1, items: ['item77', 'item78'] },
//   { id: 25, name: 'Juices', uuid: 'cat-025', sortOrder: 5, type: 'subcategory', parent: 1, items: ['item79', 'item80'] },
//   { id: 26, name: 'Cold Appetizers', uuid: 'cat-026', sortOrder: 3, type: 'subcategory', parent: 2, items: ['item81', 'item82'] },
//   { id: 27, name: 'Grilled Appetizers', uuid: 'cat-027', sortOrder: 4, type: 'subcategory', parent: 2, items: ['item83', 'item84'] },
//   { id: 28, name: 'Vegetarian Mains', uuid: 'cat-028', sortOrder: 4, type: 'subcategory', parent: 3, items: ['item85', 'item86', 'item87'] },
//   { id: 29, name: 'Seafood Mains', uuid: 'cat-029', sortOrder: 5, type: 'subcategory', parent: 3, items: ['item88', 'item89'] }
// ]);

router.beforeEach((to, from, next) => {

  if (to.meta?.modal == 'checkoutModal') {
    _open();
  }


  // nav guard - prevent to navigate some pages if different flow used
  if (rootData?.ordering?.flow === FLOW.DEFAULT) {
    if ((to.name == 'checkout')) {
      next({ name: 'customer' })
    }
  } else if (rootData?.ordering?.flow === FLOW.ONE) {
    if ((to.name == 'customer')) {
      next({ name: 'checkout' })
    }
  }

  // nav guard - prevent to navigate if customer not exists
  if ((to.name == 'paymentoptions') && !customerStore.customerId) {
    next({ name: 'cart' })
    // nav guard - if modal closed, user autonavigate from thank you to cart, so clear cart and order data
  } else if ((to.name == 'thanks') && !customerStore.customerId) {
    next({ name: 'cart' })
  } else if ((to.name == 'thanks') && !orderStore.orderId) {
    next({ name: 'cart' })
  } else if ( (from.name == 'thanks' && to.name == 'cart') || (from.name == 'orderpayment' && to.name == 'cart')){
    if (orderStore.orderId) {
      orderStore.orderId = '';
      orderStore.paymentStatus = '';
      orderStore.paymentMessage = '';
      cartStore.clear();
      useVfm().close('checkoutModal');
    }
    next()
  } else {
    next()
  }
})

onMounted(() => {
  productStore.fetchAll();
})

</script>

<template>
  <HeaderVue />
  <Hero v-if="!rootData.view?.short" />
  <MenuCategories :categories="categories" />
  <ModalsContainer />
</template>

<style lang="scss"></style>